<div class="d-flex flex-column align-items-stretch wrapper">
    <div class="d-flex align-items-center mb-3" *ngIf="label || icon">
        <i class="icon {{icon}} me-2" *ngIf="icon"></i>
        <div *ngIf="label" class="font-large color-greyish">{{label | translate}}</div>
    </div>
    <div class="d-flex align-items-center" #selectContainerRef>

        <p-multiSelect #multiple class="multi-select-custom multiple" *ngIf="selectionMode === 'multiple'"
            [styleClass]="noInput ? 'remove-input custom-multi-select enable-select form-multi-select multiple' : 'custom-multi-select enable-select form-multi-select multiple' "
            styleClass="custom-multi-select form-multi-select" dropdownIcon="icon icon-16-px-dropdown" [options]="data"
            (onChange)="onChangeHandler($event)" placeholder="noItemsPlaceholder ? {{ 'NO_ITEMS_READONLY' | translate }} : {{placeholder | translate}}" [dataKey]="field"
            optionLabel="{{field}}" optionDisabled="isDisabled" [formControl]="form" [showToggleAll]="showToggleAll"
            [maxSelectedLabels]="maxSelectedLabels || 3" [appendTo]="appendTo || 'body'"
            overlayVisible="{{overlayVisible}}" [readonly]="false" (onPanelHide)="onPanelHide()"
            [virtualScroll]="virtualScroll ? true : false" virtualScrollItemSize="38"
            (onPanelShow)="onPanelShow()" [disabled]="disabled">
            <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder && !readonly">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="!placeholder && readonly">{{ 'NO_ITEMS_READONLY' | translate }}</span>
                    <span *ngIf="placeholder && !readonly">{{ placeholder | translate }}</span>
                    <span *ngIf="placeholder && readonly">{{ 'NO_ITEMS_READONLY' | translate }}</span>
                </div>
                <div *ngIf="selectedObjects?.length > maxSelectedLabels">
                    <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
                </div>
                <ng-container *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0"
                    [ngTemplateOutlet]="selectedItemsTemplate" [ngTemplateOutletContext]="{$implicit:selectedObjects}">
                </ng-container>
            </ng-template>

            <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
                {{obj.NAME}}
                <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}">
                </ng-container>
            </ng-template>

            <ng-template *ngIf="!selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder && !readonly">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="!placeholder && readonly">{{ 'NO_ITEMS_READONLY' | translate }}</span>
                    <span *ngIf="placeholder && !readonly">{{ placeholder | translate }}</span>
                    <span *ngIf="placeholder && readonly">{{ 'NO_ITEMS_READONLY' | translate }}</span>
                </div>
                <div *ngIf="selectedObjects?.length <= maxSelectedLabels && selectedObjects?.length !==0">
                    <span *ngFor="let object of selectedObjects; let l = last"
                        pTooltip=" {{ object[field] | translate}}">
                        {{ object[field] | translate}}<span *ngIf="!l">, </span>
                    </span>
                </div>
                <div *ngIf="selectedObjects?.length > maxSelectedLabels">
                    <span>{{selectedObjects?.length}} {{'ITEM_SELECTED' | translate}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="!itemTemplate" let-obj let-i="index" pTemplate="item">
                <span *ngIf="obj.label"
                    pTooltip="{{obj?.label.toString() | translate}}">{{obj?.label.toString() | translate}}</span>
                <span *ngIf="!obj.label"
                    pTooltip="{{ obj[field] | translate}}">{{ obj[field] | translate}}</span>
            </ng-template>

        </p-multiSelect>


        <p-multiSelect #simple class="multi-select-custom simple" *ngIf="selectionMode === 'simple'"
            [styleClass]="noInput ? 'remove-input custom-multi-select enable-select form-multi-select simple' : 'custom-multi-select enable-select form-multi-select simple' "
            dropdownIcon="icon icon-16-px-dropdown" [options]="data" optionLabel="{{field}}"
            (onChange)="onChangeHandler($event)" optionDisabled="isDisabled" [ngModel]="model" (ngModelChange)="onModelChange($event)" overlayVisible="{{overlayVisible}}"
            [appendTo]="appendTo || 'body' " styleClass="custom-multi-select enable-select form-multi-select"
            placeholder="noItemsPlaceholder ? {{ 'NO_ITEMS_READONLY' | translate }} : {{placeholder | translate}}" [dataKey]="field"
            [virtualScroll]="virtualScroll ? true : false"
            virtualScrollItemSize="38" (onClick)="clicked($event)" [maxSelectedLabels]="maxSelectedLabels || 3" [readonly]="false"
            (onPanelShow)="onPanelShow()" (onHide)="onPanelHide()"
            [disabled]="disabled" [showToggleAll]="false">
            <ng-template *ngIf="selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <ng-container [ngTemplateOutlet]="selectedItemsTemplate"
                    [ngTemplateOutletContext]="{$implicit:selectedObjects}"></ng-container>
            </ng-template>

            <ng-template *ngIf="itemTemplate" let-obj let-i="index" pTemplate="item">
                {{obj.NAME}}
                <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit:obj,index:i}">
                </ng-container>
            </ng-template>


            <ng-template *ngIf="!selectedItemsTemplate" let-selectedObjects pTemplate="selectedItems">
                <div *ngIf="selectedObjects?.length===0 || !selectedObjects">
                    <span *ngIf="!placeholder">{{ 'NO_SELECTED_ITEMS' | translate }}</span>
                    <span *ngIf="placeholder">{{ placeholder | translate }}</span>
                </div>
                <div *ngIf="selectedObjects">
                    <span *ngFor="let object of selectedObjects"
                        pTooltip="{{ object[field] | translate}}">{{ object[field] | translate}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="!itemTemplate" let-obj let-i="index" pTemplate="item">
                <span *ngIf="obj.label" (click)="optionDisabled(obj?.disabled)"
                    pTooltip="{{obj?.label.toString() | translate}}">{{obj?.label.toString() | translate}}</span>
                <span *ngIf="!obj.label"
                    pTooltip="{{ obj[field] | translate}}">{{ obj[field] | translate}}</span>
            </ng-template>

        </p-multiSelect>

        <!-- <mapfre-auditlib-button class="font-medium" *ngIf="buttonText" (click)="onButtonClicked()">
                    </mapfre-auditlib-button> -->
    </div>
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="selectContainerRef"
        [skipHighlighter]="skipHighlighter"></mapfre-auditlib-form-errors>
</div>